import {
  ButtonVariant,
  FieldAction,
  HeadingLevel,
  MaterialColors,
} from "@/core/types/types";
import { TextVariant } from "@/core/components/Field/Text";
import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { FieldValues, UseFormWatch, useFormContext } from "react-hook-form";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import Telephone from "@/core/components/Telephone/Telephone";
import { FieldProps } from "@/core/components/Field";

const AddPhoneNumber = ({ field }: FieldProps) => {
  const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
  const [isPhoneError, setIsPhoneError] = useState<boolean>(false);

  const {
    formState: { errors },
    watch,
  }: {
    formState: { errors: any };
    watch: UseFormWatch<FieldValues>;
  } = useFormContext();
  const isPhoneFieldError = !errors?.[field.key];
  const formValues = watch();

  useEffect(() => {
    if (!isPhoneFieldError) {
      setPhoneNumber(formValues[field.key]);
      setIsPhoneError(false);
    }
  }, [formValues]);

  return (
    <Box>
      <Box>
        <Box mt={2} mb={3}>
          <Telephone field={field} />
        </Box>
        {isPhoneError && (
          <Box mb={3}>
            <TextVariant
              text={t("phoneNumber.error")}
              variant={HeadingLevel.Body2}
              color={MaterialColors.Error}
            />
          </Box>
        )}
        <Button
          variant={ButtonVariant.Contained}
          color={
            isPhoneFieldError && phoneNumber
              ? MaterialColors.Primary
              : "inherit"
          }
          type={FieldAction.Submit}
          sx={{ textTransform: "none" }}
          className="navigation"
        >
          {t("phoneNumber.button")}
        </Button>
      </Box>
    </Box>
  );
};

export default AddPhoneNumber;
